<template>
  <div>
    <van-popup v-model="show">
      <div id="box">
        <img class="main" @click="toNewUser" :src="newUserData.mobileUrl" />
        <img class="close" @click="close" src="@/assets/img/newUser/close.png" />
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      show: false,
    };
  },
  components: {},
  props: {
    newUserData: {
      type: Object,
      feault: () => {},
    },
    isGift: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isGift(status) {
      this.show = status;
    },
  },
  created() {},
  mounted() {},
  methods: {
    toNewUser() {
      this.$router.push({
        path: '/newUserZone',
        query: {
          activeId: this.newUserData.id,
        },
      });
    },
    close() {
      this.$emit('closeNewUser', true);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .van-popup {
  overflow-y: hidden;
  background: none;
}

#box {
  position: relative;
  width: 500px;
  height: 770px;
}
.main {
  width: 500px;
  height: 644px;
}
.close {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  width: 64px;
  height: 64px;
  margin: 0 auto;
}
</style>
